// extracted by mini-css-extract-plugin
export var socialIcon = "styles-module--socialIcon--cf964";
export var socialIcons = "styles-module--socialIcons--8493f";